import React, { useState } from "react";
import "./signup.scss";
import { auth, db } from "../../shared/FirebaseConfig";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  getAuth,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
function SignUp() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  function handle_auth() {
    if (email.length > 0 && password.length > 0 && confirmPassword.length > 0) {
      if (password === confirmPassword) {
        createUserWithEmailAndPassword(auth, email, password)
          .then((userCredential) => {
            // Signed up
            const user = userCredential.user;
            // ...
            setIsLoading(false);
            sendEmailVerification(user).then(() => {
              console.log("Email verify sent");
              navigate("/");
              // Email verification sent!
              // ...
            });
            // ToastAndroid.show("User registered succefully", ToastAndroid.LONG);
            alert("User registered successfully Pls Verify Your Email");

            // setDoc(doc(db, "Settings", email), {
            //   mode: "light",
            //   language: "English",
            // });
          })
          .catch((error) => {
            setIsLoading(false);

            if (error.code === "auth/email-already-in-use") {
              // ToastAndroid.show("Email already exist", ToastAndroid.LONG);
              // console.log('That email address is already in use!');
              alert("Email already exist");
            } else if (error.code === "auth/invalid-email") {
              // console.log('That email address is invalid!');
              // ToastAndroid.show("Envalid email", ToastAndroid.LONG);
              alert("That email address is invalid!");
            }
            alert("Something went wrong");
            // ToastAndroid.show("Something went wrong", ToastAndroid.LONG);
            // console.error('Error=====', error);
          });
      } else {
        alert("Password and Confirm Password mismatch");
      }
    } else {
      alert("Please Fill All The Field");
    }
  }
  return (
    <div className="sign_up">
      <div className="main">
        <div className="logo">
          <div className="logo_icon">
            <img src="/nextgen_logo.png" alt="" />
          </div>
          <img src="/nextgen_text.png" alt="" />
        </div>

        <div className="inputs">
          <div className="input">
            <p>Address</p>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
            />
          </div>

          <div className="input">
            <p>Password</p>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Your password"
            />
          </div>

          <div className="input">
            <p>Confirm Password</p>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm password"
            />
          </div>

          <div className="submit">
            <input
              type="submit"
              className="font-inter"
              onClick={handle_auth}
              value="Sign Up"
            />
          </div>
          <p className="sign_with">Sign in with</p>

          <div className="icons">
            <img src="/Apple.png" alt="" />
            <img src="/FB.png" alt="" />
            <img src="/Twitter.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUp;
